import React from 'react'
import _ from 'lodash'

import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { generateQRCode } from '../../../modules/portal-remote/portalService'
import { toast } from 'react-toastify';

function QRCodeModalWithRedux({ modalActions, modal }) {
  const [imageURL, setImageURL] = React.useState(null)

  React.useEffect(() => {
    const { openParams } = modal
    generateQRCode(openParams.text, openParams.imageID).then(imageURL => {
      setImageURL(imageURL)
    }).catch(error => {
      toast.error(error.message)
    })
  })

  function handleRequestClose() {
    modalActions.hideModal()
  }

  const title = _.get(modal, 'openParams.title') || 'QR Code'
  return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">{title}</p>
        {/* <a className="card-header-icon" aria-label="more options">
          <span className="icon">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </span>
        </a> */}
      </header>
      <div className="card-content">
        <div className="content">
          <figure className="image is-256x256">
            {!imageURL ? 'loading...' : <img src={imageURL} alt={title} />}
          </figure>
        </div>
      </div>
      <footer className="card-footer">
        <a
          className="card-footer-item button is-white"
          onClick={handleRequestClose}
        >
          กลับ
        </a>
      </footer>
    </div>
  )
}

export default withReduxModal(QRCodeModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/qrcode/QRCodeModalWithRedux.js